import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',

    '&.pending': {
      color: '#f5ce02',
    },
    '&.live': {
      color: theme.palette.success.light,
    },
    '&.finished': {
      color: theme.palette.primary.light,
    },
    '&.canceled': {
      color: theme.palette.primary.light,
    },
  },
}));
